module.exports = __webpack_public_path__ + "img/Noa-Blumenthal.0a5d0ea2.jpg";